// extracted by mini-css-extract-plugin
export default {"warningBar":"WarningBar_warningBar__VKlSM","text":"WarningBar_text__K4Xph"};